import { getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Gets the categories by the given identifiers, and year
 */
export const getRegionalCategories = factoryAuthService(({ familyId, regionId, segmentId, year }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/treeMapRegional/getByFamily/${year}/${regionId}/${segmentId}/${familyId}`
  )
)

/**
 * Gets the families by the given identifiers, and year.
 */
export const getRegionalFamilies = factoryAuthService(({ regionId, segmentId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/treeMapRegional/getBySegment/${year}/${regionId}/${segmentId}`)
)

/**
 * Gets the KPIs of the given region of the given year.
 */
export const getRegionalKPIs = factoryAuthService(({ regionId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/region/kpi/${year}/${regionId}`)
)

/**
 * Gets the national levels by the given year.
 */
export const getRegionalNationalLevels = factoryAuthService(({ year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/region/tradeAmount/${year}`)
)

/**
 * Gets the products by the given identifier, category, family, segment, and year.
 */
export const getRegionalProducts = factoryAuthService(({ categoryId, familyId, regionId, segmentId, year }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/treeMapRegional/getByCategory/${year}/${regionId}/${segmentId}/${familyId}/${categoryId}`
  )
)

/**
 * Gets the providers by the given identifier, and year.
 */
export const getRegionalProviders = factoryAuthService(({ direction, order, page, regionId, year }) => {
  const query = new window.URLSearchParams({ direction, order, page, year, idRegion: regionId, size: 10 })

  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/region/supplier/list?${query.toString()}`)
})

/**
 * Gets the provider bubble data by the given identifier, and year.
 */
export const getRegionalProviderBubble = factoryAuthService(({ dni, regionId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/region/supplier/bubble/${year}/${regionId}/${dni}`)
)

/**
 * Gets the provider details by the given identifier, and year.
 */
export const getRegionalProviderDetails = factoryAuthService(({ dni, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/region/supplier/detail/${year}/${dni}`)
)

/**
 * Gets the providers size by the given identifier, and year.
 */
export const getRegionalProvidersSize = factoryAuthService(({ regionId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/modalidadregion/compra/${year}/${regionId}`)
)

/**
 * Gets the purchasing mechanisms of the given region of the given year.
 */
export const getRegionalPurchasingMechanisms = factoryAuthService(({ regionId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/region/purchaseModality/${year}/${regionId}`)
)

/**
 * Gets the segments by the given identifier, and year.
 */
export const getRegionalSegments = factoryAuthService(({ regionId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/treeMapRegional/getSectors/${year}/${regionId}`)
)

/**
 * Gets the segments by the given identifier, and year.
 */
export const getSegments = factoryAuthService(({ year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/home/getSectors/${year}`)
)

/**
 * Gets the families by the given identifiers, and year.
 */
export const getFamilies = factoryAuthService(({ year, segmentId }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/home/getBySegment/${year}/${segmentId}`)
)

/**
 * Gets the categories by the given identifiers, and year
 */
export const getCategories = factoryAuthService(({ year, segmentId, familyId }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/home/getByFamily/${year}/${segmentId}/${familyId}`)
)

/**
 * Gets the products by the given identifier, category, family, segment, and year.
 */
export const getProducts = factoryAuthService(({ year, segmentId, familyId, categoryId }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/home/getByCategory/${year}/${segmentId}/${familyId}/${categoryId}`)
)
